import { Injectable } from '@angular/core';
import { CartItem } from "../cart.item.model";
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CartService {

  private cartItemsSubject = new BehaviorSubject<CartItem[]>([]);
  public cartItems$ = this.cartItemsSubject.asObservable();

  public addCartItem(items: CartItem[]) {
    let addCartItems: CartItem[] = [];
    let addQuantitiyTotal = 0;
    let addPriceTotal = 0;

    items.forEach((item: CartItem) => {
      addCartItems.push(item);
      addQuantitiyTotal += +item.quantity;
      addPriceTotal += (<number>item.quantity * <number>item.price);
    });

    const currentItems = [...this.cartItemsSubject.value];
    addCartItems.forEach(newItem => {
      const existing = currentItems.find(
        item => item.product.pzn === newItem.product.pzn
      );
      if (existing) {
        existing.quantity += newItem.quantity;
      } else {
        currentItems.push(new CartItem(newItem));
      }
    });

    this.cartItemsSubject.next(currentItems);
    //console.log("CartItem added: " + currentItems);
  }

  public removeCartItem(pzn: string) {
    const updatedItems = this.cartItemsSubject.value.filter(
      item => item.product.pzn !== pzn
    );
    this.cartItemsSubject.next(updatedItems);
  }

  public updateQuantity(pzn: string, quantity: number) {
    const items = this.cartItemsSubject.value.map(item => {
      if (item.product.pzn === pzn) {
        item.quantity = quantity;
      }
      return item;
    });
    this.cartItemsSubject.next(items);
  }

  public clearCart() {
    this.cartItemsSubject.next([]);
  }

  public getTotals() {
    const items = this.cartItemsSubject.value;
    const totalQuantity = items.reduce((sum, item) => sum + item.quantity, 0);
    const netTotal = items.reduce((sum, item) => sum + item.price * item.quantity, 0) / 100;
    const vatPercent = 19;
    const vat = netTotal * vatPercent / 100;
    const shipping = 0;
    const grossTotal = netTotal + vat + shipping;
    return { totalQuantity, netTotal, vatPercent, vat, shipping, grossTotal };
  }

  public getCartItems(): CartItem[] {
    return this.cartItemsSubject.value;
  }

}
